import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

const flexCenter = `
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

export const Info = styled.div`
    ${flexCenter}
    padding: 0 1.4rem;
    gap: .6rem;
`

export const Form = styled.form`
    ${flexCenter}
    padding: .6rem 0;
    justify-content: space-between;
    flex-grow: 1;
`

export const ContainerButton = styled.div`
    ${flexCenter}
    padding: 0 1.4rem 1.4rem;
    gap: .6rem;
`

export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  p {
    font-size: 16px;
  }
`

export const ContainerAddBatches = styled.div`
    ${flexCenter}
    padding: .6rem 0;
    justify-content: space-between;
    flex-grow: 1;
`
